<div class="row">
  <!--Search / Add btn -->
  <div class="col-12" *ngIf="step == 'chooseCustomer'">
    <form>
      <div class="form-row d-flex justify-content-between">
        <div class="col">
          <label class="sr-only" for="searchCustomer">{{ 'Standard.Search' | translate }}</label>
          <input type="text" class="form-control mb-2" id="searchCustomer" autocomplete="anyrandomstring" [(ngModel)]="who" [ngModelOptions]="{standalone:true}" (keyup)="getCustomerSearch()" placeholder="{{ 'Standard.Search' | translate }}">
        </div>
        <div class="col">
          <button type="submit" class="btn btn-primary mb-2" (click)="onChoice(null)">{{ 'Buttons.CreateCustomer' | translate }}</button>
        </div>
      </div>
    </form>
  </div>

  <!--Choose customer-->
  <div class="col-12 customerTableContainer" *ngIf="step == 'chooseCustomer' && !!output">
    <table id="customerTable" infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollUpDistance]="scrollUpDistance" [infiniteScrollThrottle]="throttle" [infiniteScrollContainer]="'#customerTableBody'" (scrolled)="onScrollDown()" aria-label="Customer table">
      <thead>
        <tr>
          <th class="colNumber">{{ 'Standard.CustomerNumber' | translate }}</th>
          <th class="colName">{{ 'Standard.Name' | translate }}</th>
          <th class="colNumber">{{ 'Standard.Phone' | translate }}</th>
          <th class="colNumber">{{ 'Standard.Mobile' | translate }}</th>
          <th class="colAddress">{{ 'Standard.Address' | translate }}</th>
          <th class="colName">{{ 'Standard.Email' | translate }}</th>
        </tr>
      </thead>
      <tbody id="customerTableBody">
        <tr *ngFor="let x of output" [ngClass]="highlightedCustomer == x.customerId ? 'selectedRow' : ''" (click)="onChoice(x.customerId)">
          <td class="colNumber">{{ x.customerNumber }}</td>
          <td class="colName">{{ x.name }}</td>
          <td class="colNumber">{{ x.customerPhone }}</td>
          <td class="colNumber">{{ x.customerMobile }}</td>
          <td class="colAddress">{{ x.customerAddress }}<span *ngIf="x.customerZipCode != '' && x.customerZipCode != null">, {{ x.customerZipCode }} {{ x.customerCity }}</span></td>
          <td class="colName">{{ x.customerEmail }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <!--Edit/Add customer-->
  <div class="col-12" *ngIf="step == 'editCustomer' || step == 'newCustomer'">
    <div class="row">
      <!--Invoice-->
      <div class="col-6" *ngIf="options.customer">
        <div class="d-flex justify-content-between">
          <h2>{{ 'Word.Invoice' | translate }}</h2>
          <button class="btn btn-sm btn-secondary" (click)="copyInvoiceToCustomer()">{{ 'Buttons.CopyInvoiceToCustomer' | translate }}</button>
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.EAN' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.ean" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Name' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.invoiceName" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Address' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.invoiceAddress" (keyup)="addressLookup('invoice')" autocomplete="anyrandomstring" spellcheck="false">
          <div id="addressList" class="addressList" *ngIf="options.addressLookUp != null && options.dawaSearchType == 'invoice'">
            <div *ngFor="let x of options.addressLookUp" (click)="dawaToAddress($event,x,'invoice')">{{ x.tekst }}</div>
          </div>
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Zipcode' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.invoiceZipCode" (keyup)="cityLookup('invoice')" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.City' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.invoiceCity" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Email' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.invoiceEmail" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Phone' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.invoicePhone" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Mobile' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.invoiceMobile" autocomplete="anyrandomstring" spellcheck="false">
        </div>
      </div>
      <!--Customer-->
      <div class="col-6" *ngIf="options.customer">
        <h2>{{ 'Standard.Customer' | translate }} <span *ngIf="options.customer.customerNumber != null"># {{ options.customer.customerNumber }}</span></h2>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Company.VatNumber' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.cvr" spellcheck="false" (keyup)="cvrSearch($event)" autocomplete="anyrandomstring" placeholder="{{ 'Standard.Search' | translate }}">
        </div>
        <div class="cvrSearchResult" *ngIf="cvrSearchData != null" (click)="spreadSearchData(cvrSearchData)">{{cvrSearchData.vat}} {{cvrSearchData.name}}</div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Name' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.customerName" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Address' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.customerAddress" (keyup)="addressLookup('customer')" autocomplete="anyrandomstring" spellcheck="false">
          <div id="addressList" class="addressList" *ngIf="options.addressLookUp != null && options.dawaSearchType == 'customer'">
            <div *ngFor="let x of options.addressLookUp" (click)="dawaToAddress($event,x,'customer')">{{ x.tekst }}</div>
          </div>
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Zipcode' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.customerZipCode" (keyup)="cityLookup('customer')" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.City' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.customerCity" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Email' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.customerMail" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Phone' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.customerPhone" autocomplete="anyrandomstring" spellcheck="false">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend input-custom-prepend">
            <span class="input-group-text input-custom-prepend">{{ 'Standard.Mobile' | translate }}</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="options.customer.customerMobile" autocomplete="anyrandomstring" spellcheck="false">
        </div>
      </div>
    </div>
  </div>
  <!--Choose delivery-->
  <div class="col-12" *ngIf="step == 'chooseDelivery'">
    <div class="row">
      <div class="col-6">
        <input type="text" class="form-control" [(ngModel)]="deliverySearch" (keyup)="onDeliverySearch()" autocomplete="'anyrandomstring'" placeholder="{{ 'Standard.Search' | translate }}...">
        <table class="table table-sm table-hover" aria-label="Delivery addresses table">
          <thead class="deliveryHead">
            <tr>
              <th scope="col">{{ 'Standard.Name' | translate }}</th>
              <th scope="col">{{ 'Standard.Address' | translate }}</th>
            </tr>
          </thead>
          <tbody class="deliveryBody">
            <tr class="table-success">
              <td colspan="2" (click)="newDelivery()"><i class="fas fa-plus-circle"></i> {{ 'Buttons.CreateNew' | translate }} {{ ('Standard.DeliveryAddress' | translate ) | lowercase }}</td>
            </tr>
            <tr *ngFor="let x of options.filteredDelivery" (click)="chooseDelivery(x)" [ngClass]="x.deliveryId == options.delivery.deliveryId ? 'selectedRow' : ''">
              <td>{{ x.customerName }}</td>
              <td>{{ x.customerAddress }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="deliveryName">{{ 'Standard.Name' | translate }}</label>
          <input type="text" class="form-control" id="deliveryName" autocomplete="anyrandomstring" [(ngModel)]="options.delivery.customerName">
        </div>
        <div class="form-group">
          <label for="deliveryAddress">{{ 'Standard.Address' | translate }}</label>
          <input type="text" class="form-control" id="deliveryAddress" (keyup)="addressLookup('delivery')" autocomplete="anyrandomstring" [(ngModel)]="options.delivery.customerAddress">
          <div id="addressList" class="addressList" *ngIf="options.addressLookUp != null && options.dawaSearchType == 'delivery'">
            <div *ngFor="let x of options.addressLookUp" (click)="dawaToAddress($event,x,'delivery')">{{ x.tekst }}</div>
          </div>
        </div>
        <div class="form-group">
          <label for="deliveryZipCode">{{ 'Standard.Zipcode' | translate }}</label>
          <input type="text" class="form-control" id="deliveryZipCode" (keyup)="cityLookup('delivery')" autocomplete="anyrandomstring" [(ngModel)]="options.delivery.customerZipCode">
        </div>
        <div class="form-group">
          <label for="deliveryCity">{{ 'Standard.City' | translate }}</label>
          <input type="text" class="form-control" id="deliveryCity" autocomplete="anyrandomstring" [(ngModel)]="options.delivery.customerCity">
        </div>
        <div class="form-group">
          <label for="deliveryMail">{{ 'Standard.Email' | translate }}</label>
          <input type="text" class="form-control" id="deliveryMail" autocomplete="anyrandomstring" [(ngModel)]="options.delivery.customerMail">
        </div>
        <div class="form-group">
          <label for="deliveryPhone">{{ 'Standard.Phone' | translate }}</label>
          <input type="text" class="form-control" id="deliveryPhone" autocomplete="anyrandomstring" [(ngModel)]="options.delivery.customerPhone">
        </div>
        <div class="form-group">
          <label for="deliveryPhone">{{ 'Standard.Mobile' | translate }}</label>
          <input type="text" class="form-control" id="deliveryPhone" autocomplete="anyrandomstring" [(ngModel)]="options.delivery.customerMobile">
        </div>
      </div>
    </div>
  </div>
  <!--Choose contact-->
  <div class="col-12" *ngIf="step == 'chooseContact'">
    <div class="row">
      <div class="col-6">
        <input type="text" class="form-control" [(ngModel)]="contactSearch" autocomplete="'anyrandomstring'" (keyup)="onContactSearch()" placeholder="{{ 'Standard.Search' | translate }}...">
        <table class="table table-sm table-hover" aria-label="Contacts table">
          <thead class="deliveryHead">
            <tr>
              <th scope="col">{{ 'Standard.Name' | translate }}</th>
              <th scope="col">{{ 'Standard.Address' | translate }}</th>
            </tr>
          </thead>
          <tbody class="deliveryBody">
            <tr class="table-success">
              <td colspan="2" (click)="newContact()"><i class="fas fa-plus-circle"></i> {{ 'Buttons.CreateNew' | translate }} {{ ('Standard.ContactInfo' | translate ) | lowercase }}</td>
            </tr>
            <tr *ngFor="let x of options.filteredContacts" (click)="chooseContact(x)" [ngClass]="x.id == options.contact.id ? 'selectedRow' : ''">
              <td>{{ x.name }}</td>
              <td>{{ x.address }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="contactName">{{ 'Standard.Name' | translate }}</label>
          <input type="text" class="form-control" id="contactName" autocomplete="'anyrandomstring'" [(ngModel)]="options.contact.name">
        </div>
        <div class="form-group">
          <label for="contactAddress">{{ 'Standard.Address' | translate }}</label>
          <input type="text" class="form-control" id="contactAddress" (keyup)="addressLookup('contact')" autocomplete="anyrandomstring" [(ngModel)]="options.contact.address">
          <div id="addressList" class="addressList" *ngIf="options.addressLookUp != null && options.dawaSearchType == 'contact'">
            <div *ngFor="let x of options.addressLookUp" (click)="dawaToAddress($event,x,'contact')">{{ x.tekst }}</div>
          </div>
        </div>
        <div class="form-group">
          <label for="contactZipCode">{{ 'Standard.Zipcode' | translate }}</label>
          <input type="text" class="form-control" id="contactZipCode" (keyup)="cityLookup('contact')" autocomplete="anyrandomstring" [(ngModel)]="options.contact.zipCode">
        </div>
        <div class="form-group">
          <label for="contactCity">{{ 'Standard.City' | translate }}</label>
          <input type="text" class="form-control" id="contactCity" autocomplete="anyrandomstring" [(ngModel)]="options.contact.city">
        </div>
        <div class="form-group">
          <label for="contactMail">{{ 'Standard.Email' | translate }}</label>
          <input type="text" class="form-control" id="contactMail" autocomplete="anyrandomstring" [(ngModel)]="options.contact.email">
        </div>
        <div class="form-group">
          <label for="contactPhone">{{ 'Standard.Phone' | translate }}</label>
          <input type="text" class="form-control" id="contactPhone" autocomplete="anyrandomstring" [(ngModel)]="options.contact.phone">
        </div>
        <div class="form-group">
          <label for="contactMobile">{{ 'Standard.Mobile' | translate }}</label>
          <input type="text" class="form-control" id="contactMobile" autocomplete="anyrandomstring" [(ngModel)]="options.contact.mobile">
        </div>
        <div class="form-group">
          <label for="contactMobile">{{ 'Standard.EAN' | translate }}</label>
          <input type="text" class="form-control" id="contactMobile" autocomplete="anyrandomstring" [(ngModel)]="options.contact.ean">
        </div>
      </div>
    </div>
  </div>
  <!-- Final (overview)-->
  <div class="col-12 d-flex justify-content-between" *ngIf="step == 'final' && options.customer != null">
    <div class="card shadow-sm address" [ngClass]="options.notificationAddress == 'invoice' ? 'activeAddress' : ''">
      <div class="card-body p-1">
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-grow-1">
            <h5 class="card-title text-bold">{{ 'Word.Invoice' | translate }}</h5>
            <div class="ml-2" (click)="communicate({currentStep:'editCustomer', previousStep:'final' })" *ngIf="!restrictAccess"><i class="fas fa-pencil mb-1"></i></div>
          </div>
          <span (click)="updateNotification('invoice')" [ngClass]="options.notificationAddress == 'invoice' ? 'text-primary' : 'text-secondary'"><i class="fas fa-envelope"></i></span>
        </div>
        <div class="card-text">
          <div class="d-flex"><span [routerLink]="['/Customers/Customerdetails/' + options.customer.customerId]"><i class="fas fa-user-alt"></i></span><span>{{options.customer.invoiceName}}</span></div>
          <div class="d-flex" (click)="openAddressInGoogle('invoice')"><span><i class="fas fa-map-marker-alt"></i></span><span>{{options.customer.invoiceAddress}}</span></div>
          <div class="d-flex"><span (click)="openCityInGoogle('invoice')"><i class="fas fa-city"></i></span><span>{{options.customer.invoiceZipCode}} {{options.customer.invoiceCity}}</span></div>
          <div class="d-flex"><span><a href="mailto:{{options.customer.invoiceEmail}}"><i class="fas fa-at"></i></a></span><span>{{options.customer.invoiceEmail}}</span><span *ngIf="options.notificationAddress == 'invoice' && options.notificationMailWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
          <div class="d-flex"><span><a href="tel:{{options.customer.invoicePhone}}"><i class="fas fa-phone"></i></a></span><span>{{options.customer.invoicePhone}}</span></div>
          <div class="d-flex"><span><a href="tel:{{options.customer.invoiceMobile}}"><i class="fas fa-mobile-alt mr-1"></i></a></span><span>{{options.customer.invoiceMobile}}</span><span *ngIf="options.notificationAddress == 'invoice' && options.notificationMobileWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
          <div class="d-flex">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            </span>
            <span>{{ option?.customer?.ean }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card shadow-sm address" [ngClass]="options.notificationAddress == 'customer' ? 'activeAddress' : ''">
      <div class="card-body p-1">
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-grow-1">
            <h5 class="card-title text-bold">{{ 'Standard.Customer' | translate }}</h5>
            <div class="ml-2" (click)="communicate({currentStep:'editCustomer', previousStep:'final' })" *ngIf="!restrictAccess"><i class="fas fa-pencil mb-1"></i></div>
          </div>
          <span (click)="updateNotification('customer')" [ngClass]="options.notificationAddress == 'customer' ? 'text-primary' : 'text-secondary'"><i class="fas fa-envelope"></i></span>
        </div>
        <div class="card-text">
          <div class="d-flex"><span [routerLink]="['/Customers/Customerdetails/' + options.customer.customerId]"><i class="fas fa-user-alt"></i></span><span>{{options.customer.customerName}}</span></div>
          <div class="d-flex"><span (click)="openAddressInGoogle('customer')"><i class="fas fa-map-marker-alt"></i></span><span>{{options.customer.customerAddress}}</span></div>
          <div class="d-flex"><span (click)="openCityInGoogle('customer')"><i class="fas fa-city"></i></span><span>{{options.customer.customerZipCode}} {{options.customer.customerCity}}</span></div>
          <div class="d-flex"><span><a href="mailto:{{options.customer.customerMail}}"><i class="fas fa-at"></i></a></span><span>{{options.customer.customerMail}}</span><span *ngIf="options.notificationAddress == 'customer' && options.notificationMailWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
          <div class="d-flex"><span><a href="tel:{{options.customer.customerPhone}}"><i class="fas fa-phone"></i></a></span><span>{{options.customer.customerPhone}}</span></div>
          <div class="d-flex"><span><a href="tel:{{options.customer.customerMobile}}"><i class="fas fa-mobile-alt mr-1"></i></a></span><span>{{options.customer.customerMobile}}</span><span *ngIf="options.notificationAddress == 'customer' && options.notificationMobileWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
          <div>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="card shadow-sm address" [ngClass]="options.notificationAddress == 'delivery' ? 'activeAddress' : ''" *ngIf="!onlyCustomerAndInvoice">
      <div class="card-body p-1">
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-grow-1">
            <h5 class="card-title text-bold">{{ 'Standard.Delivery' | translate }}</h5>
            <div class="ml-2" (click)="communicate({currentStep:'chooseDelivery', previousStep:'final' })" *ngIf="!restrictAccess && deliveryExists()"><i class="fas fa-pencil mb-1"></i></div>
          </div>
          <span (click)="updateNotification('delivery')" [ngClass]="options.notificationAddress == 'delivery' ? 'text-primary' : 'text-secondary'"><i class="fas fa-envelope"></i></span>
        </div>
        <div class="card-text" *ngIf="deliveryExists()">
          <div class="d-flex"><span><i class="fas fa-user-alt"></i></span><span>{{options.delivery?.customerName}}</span></div>
          <div class="d-flex"><span (click)="openAddressInGoogle('delivery')"><i class="fas fa-map-marker-alt"></i></span><span>{{options.delivery?.customerAddress}}</span></div>
          <div class="d-flex"><span (click)="openCityInGoogle('delivery')"><i class="fas fa-city"></i></span><span>{{options.delivery?.customerZipCode}} {{options.delivery?.customerCity}}</span></div>
          <div class="d-flex"><span><a href="mailto:{{options.delivery?.customerMail}}"><i class="fas fa-at"></i></a></span><span>{{options.delivery?.customerMail}}</span><span *ngIf="options.notificationAddress == 'delivery' && options.notificationMailWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
          <div class="d-flex"><span><a href="tel:{{options.delivery?.customerPhone}}"><i class="fas fa-phone"></i></a></span><span>{{options.delivery?.customerPhone}}</span></div>
          <div class="d-flex"><span><a href="tel:{options.delivery?.customerMobile}}"><i class="fas fa-mobile-alt mr-1"></i></a></span><span>{{options.delivery?.customerMobile}}</span><span *ngIf="options.notificationAddress == 'delivery' && options.notificationMobileWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
        </div>
        <div class="card-text text-center mt-4" *ngIf="!deliveryExists()" (click)="communicate({currentStep:'chooseDelivery', previousStep:'final' })">
          <i class="fas fa-plus-circle mr-2"></i>{{ 'Buttons.Add' | translate }} {{ ('Standard.DeliveryAddress' | translate ) | lowercase }}
        </div>
      </div>
    </div>
    <div class="card shadow-sm address" [ngClass]="options.notificationAddress == 'contact' ? 'activeAddress' : ''" *ngIf="!onlyCustomerAndInvoice">
      <div class="card-body p-1">
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-grow-1">
            <h5 class="card-title text-bold">{{ 'Standard.ContactAddress' | translate }}</h5>
            <div class="ml-2" (click)="communicate({currentStep:'chooseContact', previousStep:'final' })" *ngIf="!restrictAccess && contactExists()"><i class="fas fa-pencil mb-1"></i></div>
          </div>
          <span (click)="updateNotification('contact')" [ngClass]="options.notificationAddress == 'contact' ? 'text-primary' : 'text-secondary'"><i class="fas fa-envelope"></i></span>
        </div>
        <div class="card-text" *ngIf="contactExists()">
            <div class="d-flex"><span><i class="fas fa-user-alt"></i></span><span>{{options.contact?.name}}</span></div>
            <div class="d-flex"><span (click)="openAddressInGoogle('contact')"><i class="fas fa-map-marker-alt"></i></span><span>{{options.contact?.address}}</span></div>
            <div class="d-flex"><span (click)="openCityInGoogle('contact')"><i class="fas fa-city"></i></span><span>{{options.contact?.zipCode}} {{options.contact?.city}}</span></div>
            <div class="d-flex"><span><a href="mailto:{{options.contact?.email}}"><i class="fas fa-at"></i></a></span><span>{{options.contact?.email}}</span><span *ngIf="options.notificationAddress == 'contact' && options.notificationMailWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
            <div class="d-flex"><span><a href="tel:{{options.contact?.phone}}"><i class="fas fa-phone"></i></a></span><span>{{options.contact?.phone}}</span></div>
            <div class="d-flex"><span><a href="tel:{options.contact?.mobile}}"><i class="fas fa-mobile-alt mr-1"></i></a></span><span>{{options.contact?.mobile}}</span><span *ngIf="options.notificationAddress == 'contact' && options.notificationMobileWarning"><i class="fas fa-exclamation-circle text-danger"></i></span></div>
            <div class="d-flex" *ngIf="options.contact.ean"><span><i class="fa-solid fa-barcode"></i></span><span>{{options.contact?.ean}}</span></div>
        </div>
        <div class="card-text text-center mt-4" *ngIf="!contactExists()" (click)="communicate({currentStep:'chooseContact', previousStep:'final' })">
          <i class="fas fa-plus-circle mr-2"></i>{{ 'Buttons.Add' | translate }} {{ ('Standard.ContactInfo' | translate ) | lowercase }}
        </div>
      </div>
    </div>
  </div>
</div>
